const Footer = () => {
   return <h3 className="footer">Scorpion Freelancers @ 2023</h3>;
};

export default Footer;
